var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgUp(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 9,
    height: 8
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#0B0B0A",
    fillRule: "evenodd",
    d: "M0 7.998L9 8 4.5 0 0 7.998"
  })));
}

export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSI5IiBoZWlnaHQ9IjgiIHZpZXdCb3g9IjAgMCA5IDgiPgogIDxwb2x5bGluZSBmaWxsPSIjMEIwQjBBIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiIHBvaW50cz0iMzMgMTY2Ljk5OCA0MiAxNjcgMzcuNSAxNTkgMzMgMTY2Ljk5OCIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoLTMzIC0xNTkpIi8+Cjwvc3ZnPgo=";
export { SvgUp as ReactComponent };